import { render, staticRenderFns } from "./PermalinkPlugin.vue?vue&type=template&id=07b6dcb1&scoped=true"
import script from "./PermalinkPlugin.vue?vue&type=script&lang=ts"
export * from "./PermalinkPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PermalinkPlugin.vue?vue&type=style&index=0&id=07b6dcb1&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "07b6dcb1",
  null
  ,true
)

export default component.exports